import 'css-chunk:../../src/components/OnshapeExplorer/OnshapeDocumentExplorer/index.module.scss';export default {
  "thumbnail": "_thumbnail_nsdfe_1"
};